var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDplinkLocationTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.441 5.94853L14.4959 7.89365C14.5671 8.2579 14.6044 8.63442 14.6044 9.01944C14.6044 12.2442 11.99 14.8586 8.76527 14.8586C5.54056 14.8586 2.92638 12.2442 2.92638 9.01943C2.92638 5.79471 5.54056 3.18054 8.76527 3.18054C10.4915 3.18054 12.0426 3.92934 13.1111 5.12L14.8285 3.40277C13.3194 1.77378 11.1615 0.754631 8.76528 0.754395C4.20056 0.754395 0.5 4.45496 0.5 9.01991C0.5 17.5308 8.71078 21.2212 8.76527 21.2457C8.81977 21.2212 17.0305 17.5308 17.0305 9.01991C17.0305 7.9347 16.8213 6.89809 16.4408 5.94877L16.441 5.94853Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87358 12.8763L4.61249 8.61523L6.05181 7.17591L8.87358 9.99769L16.0607 2.81055L17.5 4.24986L8.87358 12.8763Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDplinkLocationTick);
export default __webpack_public_path__ + "static/media/dplink-location-tick.7f4ca0595b356dc2ad5601b6da32b673.svg";
export { ForwardRef as ReactComponent };